module.exports = __webpack_public_path__ + "img/contactDetailsBlack.08fe84c8.svg";